module.exports = __webpack_public_path__ + "static/media/Fly.9dd6a06b.PNG";